import React, { useState } from "react";
import { api } from "../shared/axiosInstance";

const InviteUserModal = ({ isOpen, onClose, onInvite }) => {
    const [email, setEmail] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [role, setRole] = useState("Recruiter");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleInvite = async () => {
        if (!email || !firstName || !lastName || !role) {
            setError("All fields are required.");
            return;
        }
        setLoading(true);
        setError("");
        try {
            const token = localStorage.getItem("token");
            await api.post(
                "/employer/invite",
                { email, firstName, lastName, role },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            onInvite();
            onClose();
            // Reset the form
            setEmail("");
            setFirstName("");
            setLastName("");
            setRole("Recruiter");
        } catch (err) {
            console.error("Error inviting user:", err.response?.data || err);
            setError(err.response?.data?.message || err.response?.data?.error || "Error inviting user.");
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-bluegray p-6 rounded-lg shadow-lg w-[400px] relative">
                <button onClick={onClose} className="absolute top-2 right-2 text-lightgray text-2xl font-bold">
                    &times;
                </button>
                <h2 className="text-orange text-xl font-bold mb-4 text-center">Invite User to Company</h2>
                {error && <p className="text-red-500 mb-2">{error}</p>}
                <div className="mb-4">
                    <label className="block text-lightgray font-semibold mb-1">Email</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email"
                        className="w-full p-2 rounded bg-deepblue text-lightgray border border-lightblue"
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-lightgray font-semibold mb-1">First Name</label>
                    <input
                        type="text"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        placeholder="First Name"
                        className="w-full p-2 rounded bg-deepblue text-lightgray border border-lightblue"
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-lightgray font-semibold mb-1">Last Name</label>
                    <input
                        type="text"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        placeholder="Last Name"
                        className="w-full p-2 rounded bg-deepblue text-lightgray border border-lightblue"
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-lightgray font-semibold mb-1">Role</label>
                    <select
                        value={role}
                        onChange={(e) => setRole(e.target.value)}
                        className="w-full p-2 rounded bg-deepblue text-white border border-lightblue"
                    >
                        <option value="Recruiter">Recruiter</option>
                        <option value="Company Admin">Company Admin</option>
                    </select>
                </div>
                <button
                    onClick={handleInvite}
                    disabled={loading}
                    className="w-full p-3 bg-orange text-darkblue font-bold rounded hover:bg-deeporange"
                >
                    {loading ? "Inviting..." : "Send Invite"}
                </button>
            </div>
        </div>
    );
};

export default InviteUserModal;
